import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router'
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { state } from '@angular/animations';
import { ReferralService } from 'src/app/services/referral.service';
import { LoginService } from 'src/app/services/login.service';


@Component({
  selector: 'app-forget-referral',
  templateUrl: './forget-referral.component.html',
  styleUrls: ['./forget-referral.component.css']
})
export class ForgetReferralComponent implements OnInit {
  isRequired: boolean = false;
  hide = true;
  loading = false;
  referralEmail = '';
  viewdata: any;

  constructor(
    private router: Router,
    private referralService: ReferralService,
    private loginService: LoginService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
  }

  sendReferralCode() {
    this.loading = true;
    if (this.referralEmail == '') {
      this.isRequired = true;
      this.loading = false;
      return;
    }
    this.isRequired = false;
    this.loginService.forgetReferral(this.referralEmail)
      .subscribe(
        result => {
          this.toastr.success('Referral Code Has Send To Your Email');
          this.loading = false;
          this.router.navigate([""]);
        },
        error => {
          if (error.error.Status === 404) {
            this.loading = false;
            this.toastr.error(error.error.Message)
            console.log(error.error.Message);
          }
        },
        () => {
        }
      );

  }

  cancel() {
    this.router.navigate([""]);
  }

}
